import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartCardDateCalendarSelect from "./ChartCardDateCalendarSelect";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "top",
    },
  },
};

const BarChartDateCalendarSelector = ({ dataToShow, title, selectedDate, setSelectedDate, minDate, maxDate }) => {
  let dataSets = [];
  Object.keys(dataToShow).map(function (data) {
    if (data !== "labels") {
      if (Array.isArray(dataToShow[data])) {
        dataSets = dataToShow[data];
      } else {
        dataSets.push(dataToShow[data]);
      }
    }
  });
  const data = {
    labels: dataToShow.labels,
    datasets: dataSets,
  };

  return (
    <ChartCardDateCalendarSelect
      title={title}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      minDate={minDate}
      maxDate={maxDate}
    >
      <Bar
        data={data}
        options={options}
        style={{ height: "100%" }}
      />
    </ChartCardDateCalendarSelect>
  );
}

export default BarChartDateCalendarSelector